import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthConfig } from '@capturum/auth';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

interface SsoResponse {
  url: string;
}

@Injectable()
export class SsoLoginResolver implements Resolve<SsoResponse> {
  constructor(private http: HttpClient, protected config: AuthConfig) {
  }

  public resolve(): Observable<SsoResponse> {
    const url = `${this.config.baseUrl}/sso-login`;

    return this.http.get<SsoResponse>(url).pipe(
      tap((response) => {
        if (response) {
          // Redirect the user to the Microsoft authentication page
          window.location.href = response.url;
        }
      }),
    );
  }
}
